import { useMutation } from '@tanstack/react-query';

export const useSetCreateTaskShortcutMutation = () =>
  useMutation({
    mutationFn: async (shortcut: string | null) =>
      window.electron?.setCreateTaskPopoverShortcut?.(shortcut),
  });
